@if (message) {
  <div class="toast" [ngClass]="{ fade: hideToast }">
    {{ message }}
  </div>
}
